import { useReadContract } from "wagmi";
import useDappChain from "./useDappChain";
import useDappConfig from "./useDappConfig";
import { formatUnits } from "viem";
import { useSelector } from "react-redux";
import { ETH, WETHE } from "@config/contractsConfig";
import { safeParseUnits } from "@lib/utils";

const useDepositEstimate = (amount: string) => {
  const { chain, isEthereumChain } = useDappChain();
  const { config, isRestakeSupported } = useDappConfig();

  // safeParseUnits never throws on malformed input (hex, exponential, multi-dot,
  // Infinity, …) — those previously crashed this hook during render.
  const formattedAmount = safeParseUnits(amount, 18);

  const { selectedERC20 } = useSelector((state: any) => state.user);

  const args: (bigint | string)[] = [formattedAmount];

  // For Avalanche, WETHE is the native token and should be treated like ETH
  // For other chains, only add token address if it's not the native token
  if (
    selectedERC20 !== ETH &&
    selectedERC20 !== WETHE &&
    config.tokens[selectedERC20]?.address
  ) {
    args.push(config.tokens[selectedERC20].address);
  }

  const { data } = useReadContract({
    ...config.interactionPools.lrtDepositPool,
    functionName: "viewSwapRsETHAmountAndFee",
    args: args,
    query: {
      enabled:
        chain && isRestakeSupported && !isEthereumChain && formattedAmount > 0n,
    },
  });

  return data
    ? {
        returns: formatUnits((data as any)[0] as bigint, 18),
        fees: formatUnits((data as any)[1] as bigint, 18),
      }
    : { returns: "0", fees: "0" };
};

export default useDepositEstimate;
